import { Instance } from 'mobx-state-tree';
import { RouteStopSchedulingDtoModelBase } from './RouteStopSchedulingDtoModel.base';

/* The TypeScript type of an instance of RouteStopSchedulingDtoModel */
export interface RouteStopSchedulingDtoModelType extends Instance<typeof RouteStopSchedulingDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopSchedulingDtoModel */
export { selectFromRouteStopSchedulingDto, routeStopSchedulingDtoModelPrimitives, RouteStopSchedulingDtoModelSelector } from './RouteStopSchedulingDtoModel.base';

/**
 * RouteStopSchedulingDtoModel
 *
 * Route scheduling event
 */
export const RouteStopSchedulingDtoModel = RouteStopSchedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
